import { computed } from 'vue'
import { careServicesUrls } from '@web/common/ExternalConfig/getters'

export function useSupportContacts () {
  const careServicesUrlsItem = computed(() => careServicesUrls())

  const formatPhoneForWhatsApp = (phoneNumber: string): string => {
    if (!phoneNumber) return ''

    const cleanNumber = phoneNumber.replace(/[^\d+]/g, '')

    if (cleanNumber.startsWith('8')) {
      return '+7' + cleanNumber.substring(1)
    }

    if (cleanNumber.startsWith('7')) {
      return '+' + cleanNumber
    }

    if (!cleanNumber.startsWith('+')) {
      return '+' + cleanNumber
    }

    return cleanNumber
  }

  const whatsappUrl = computed(() => {
    const phoneNumber = careServicesUrlsItem.value.whatsapp
    if (!phoneNumber) return ''

    const formattedPhone = formatPhoneForWhatsApp(phoneNumber)
    return `https://wa.me/${formattedPhone}`
  })

  const telegramUrl = computed(() => {
    return careServicesUrlsItem.value.telegram
  })

  const maxUrl = computed(() => {
    return careServicesUrlsItem.value.max
  })

  function openWhatsapp () {
    window.open(whatsappUrl.value, '_blank')
  }
  function openTelegram () {
    window.open(careServicesUrlsItem.value.telegram, '_blank')
  }
  function openMax () {
    window.open(careServicesUrlsItem.value.max, '_blank')
  }

  return {
    whatsappUrl,
    telegramUrl,
    maxUrl,
    openWhatsapp,
    openTelegram,
    openMax
  }
}

export default useSupportContacts
